module.exports = "<article data-ui-view=\"dashboard\" id=\"dashboard\">\r\n</article>\r\n";